'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _invertBy3 = require('lodash/invertBy');

var _invertBy4 = _interopRequireDefault(_invertBy3);

var _dec, _dec2, _class, _desc, _value, _class2, _class3, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = require('react-redux');

var _contacts = require('redux/modules/contacts');

var contactsActions = _interopRequireWildcard(_contacts);

var _reactI18next = require('react-i18next');

var _components = require('components');

var _utils = require('helpers/utils');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var SelectGroupsList = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    groupsList: state.contacts.groupsListData,
    groupsListLoading: state.contacts.groupsListLoading,
    groupsListLoaded: state.contacts.groupsListLoaded
  };
}, (0, _extends4.default)({}, contactsActions)), _dec2 = (0, _reactI18next.translate)(['common']), _dec(_class = _dec2(_class = (_class2 = (_temp = _class3 = function (_Component) {
  (0, _inherits3.default)(SelectGroupsList, _Component);

  function SelectGroupsList() {
    var _ref;

    (0, _classCallCheck3.default)(this, SelectGroupsList);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = SelectGroupsList.__proto__ || (0, _getPrototypeOf2.default)(SelectGroupsList)).call.apply(_ref, [this].concat(args)));

    _this.state = { checkedGroups: {} };
    return _this;
  }

  (0, _createClass3.default)(SelectGroupsList, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.loadGroups();
    }
  }, {
    key: 'toggleGroupChecked',
    value: function toggleGroupChecked(e, id) {
      this.setState({
        checkedGroups: (0, _extends4.default)({}, this.state.checkedGroups, (0, _defineProperty3.default)({}, id, !this.state.checkedGroups[id]))
      });
    }
  }, {
    key: 'select',
    value: function select() {
      var onSelect = this.props.onSelect;

      var _ref2 = this.state || {},
          checkedGroups = _ref2.checkedGroups;

      var checkedGroupsArr = (0, _invertBy4.default)(checkedGroups).true || []; // eslint-disable-line dot-notation
      onSelect(checkedGroupsArr);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          t = _props.t,
          groupsList = _props.groupsList,
          groupsListLoading = _props.groupsListLoading,
          groupsListLoaded = _props.groupsListLoaded;
      var checkedGroups = this.state.checkedGroups;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _components.List,
          null,
          _react2.default.createElement(
            _components.ListItem,
            { fullWidth: true, isTitle: true },
            _react2.default.createElement(
              'div',
              null,
              t('Group Name')
            ),
            _react2.default.createElement('div', null)
          ),
          groupsList.map(function (group) {
            return _react2.default.createElement(
              _components.ListItem,
              { fullWidth: true, key: group.id, onClick: function onClick(e) {
                  return _this2.toggleGroupChecked(e, group.id);
                } },
              _react2.default.createElement(
                'div',
                null,
                group.name
              ),
              _react2.default.createElement(
                'div',
                { className: 'text-center' },
                _react2.default.createElement(_components.Checkbox, {
                  className: 'padding-5 inline',
                  checked: checkedGroups[group.id],
                  onClick: _utils.stopEvent
                })
              )
            );
          })
        ),
        groupsListLoading && _react2.default.createElement(_components.Loader, null),
        groupsListLoaded && _react2.default.createElement(
          'div',
          { className: 'text-right margin-top-20' },
          _react2.default.createElement(
            'button',
            { type: 'button', className: 'btn btn-primary wide', onClick: this.select },
            t('Ok')
          )
        )
      );
    }
  }]);
  return SelectGroupsList;
}(_react.Component), _class3.propTypes = {
  groupsList: _propTypes2.default.array,
  groupsListLoaded: _propTypes2.default.bool,
  groupsListLoading: _propTypes2.default.bool,
  loadGroups: _propTypes2.default.func,
  onSelect: _propTypes2.default.func.isRequired,
  t: _propTypes2.default.func
}, _temp), (_applyDecoratedDescriptor(_class2.prototype, 'select', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class2.prototype, 'select'), _class2.prototype)), _class2)) || _class) || _class);
exports.default = SelectGroupsList;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Contacts/SelectGroupsList.js
// module id = 1979
// module chunks = 1